export enum PolicyType {
    TermsAndConditions = 1,
    PrivacyPolicy = 2,
    EULA = 3
}
